import { ApiKeyAccessLevel, ApiKeyExpiration, ApiKeyScope, ApiKeyStatus } from '@shared/models';

import { BadgeConfig } from './badge.consts';

export interface ApiKeyScopeOption {
  scope: ApiKeyScope;
  icon: string;
  label: string;
  description: string;
}

// TODO (Denis) - this should be based on CompanyModules
export const API_KEY_SCOPE_OPTIONS: ApiKeyScopeOption[] = [
  {
    scope: ApiKeyScope.Projects,
    icon: 'pi-briefcase',
    label: 'settings.developer.scope.projects',
    description: 'settings.developer.scope.projectsDescription',
  },
  {
    scope: ApiKeyScope.Customers,
    icon: 'pi-id-card',
    label: 'settings.developer.scope.customers',
    description: 'settings.developer.scope.customersDescription',
  },
  {
    scope: ApiKeyScope.Materials,
    icon: 'pi-box',
    label: 'settings.developer.scope.materials',
    description: 'settings.developer.scope.materialsDescription',
  },
  {
    scope: ApiKeyScope.MaterialPackages,
    icon: 'pi-th-large',
    label: 'settings.developer.scope.materialPackages',
    description: 'settings.developer.scope.materialPackagesDescription',
  },
  {
    scope: ApiKeyScope.EmployeeHours,
    icon: 'pi-clock',
    label: 'settings.developer.scope.employeeHours',
    description: 'settings.developer.scope.employeeHoursDescription',
  },
  {
    scope: ApiKeyScope.Users,
    icon: 'pi-users',
    label: 'settings.developer.scope.users',
    description: 'settings.developer.scope.usersDescription',
  },
];

export const API_KEY_SCOPE_LABELS: Record<ApiKeyScope, string> = {
  [ApiKeyScope.Projects]: 'settings.developer.scope.projects',
  [ApiKeyScope.Customers]: 'settings.developer.scope.customers',
  [ApiKeyScope.Materials]: 'settings.developer.scope.materials',
  [ApiKeyScope.MaterialPackages]: 'settings.developer.scope.materialPackages',
  [ApiKeyScope.EmployeeHours]: 'settings.developer.scope.employeeHours',
  [ApiKeyScope.Users]: 'settings.developer.scope.users',
};

export const API_KEY_ACCESS_LEVEL_OPTIONS: { value: ApiKeyAccessLevel; label: string }[] = [
  { value: ApiKeyAccessLevel.None, label: 'settings.developer.accessLevel.none' },
  { value: ApiKeyAccessLevel.Read, label: 'settings.developer.accessLevel.read' },
  { value: ApiKeyAccessLevel.Write, label: 'settings.developer.accessLevel.write' },
];

export const API_KEY_ACCESS_LEVEL_LABELS: Record<ApiKeyAccessLevel, string> = {
  [ApiKeyAccessLevel.None]: 'settings.developer.accessLevel.none',
  [ApiKeyAccessLevel.Read]: 'settings.developer.accessLevel.read',
  [ApiKeyAccessLevel.Write]: 'settings.developer.accessLevel.write',
};

export const API_KEY_ACCESS_LEVEL_BADGE: Record<ApiKeyAccessLevel, BadgeConfig> = {
  [ApiKeyAccessLevel.None]: { icon: 'pi-ban', color: 'gray' },
  [ApiKeyAccessLevel.Read]: { icon: 'pi-eye', color: 'blue' },
  [ApiKeyAccessLevel.Write]: { icon: 'pi-pencil', color: 'orange' },
};

export const API_KEY_STATUS_LABELS: Record<ApiKeyStatus, string> = {
  [ApiKeyStatus.Active]: 'settings.developer.status.active',
  [ApiKeyStatus.Expired]: 'settings.developer.status.expired',
  [ApiKeyStatus.Revoked]: 'settings.developer.status.revoked',
};

export const API_KEY_STATUS_BADGE: Record<ApiKeyStatus, BadgeConfig> = {
  [ApiKeyStatus.Active]: { icon: 'pi-check-circle', color: 'green' },
  [ApiKeyStatus.Expired]: { icon: 'pi-clock', color: 'yellow' },
  [ApiKeyStatus.Revoked]: { icon: 'pi-ban', color: 'red' },
};

export const API_KEY_EXPIRATION_OPTIONS: { value: ApiKeyExpiration; label: string }[] = [
  { value: ApiKeyExpiration.Days30, label: 'settings.developer.expiration.days30' },
  { value: ApiKeyExpiration.Days90, label: 'settings.developer.expiration.days90' },
  { value: ApiKeyExpiration.Days365, label: 'settings.developer.expiration.days365' },
  { value: ApiKeyExpiration.Never, label: 'settings.developer.expiration.never' },
];
